export default {
	buttons: {
		cancel: 'Cancel',
		generate: 'Generate',
		create: 'Create',
	},
	generateLlm: {
		title: 'Generate AI content',
		description: 'Use AI to generate content for this entity.',
		descriptionNamed:
			'Use AI to generate content for {{entityType}} "{{entityName}}".',
		facetLabel: 'Facet',
		selectFacet: 'Select facet',
		cancel: 'Cancel',
		generate: 'Generate',
		entityTypes: {
			course: '{{mainEntityLabel}}',
			module: 'Module',
			topic: 'Topic',
			resource: 'Resource',
		},
	},
	generateDiagram: {
		title: 'Create diagram',
		description: 'Use AI to generate a diagram or create a blank diagram.',
		generateWithAi: 'Generate with AI',
		focusAreas: 'Focus areas',
		focusAreasPlaceholder: 'Optional: key areas to focus on',
	},
	collectResources: {
		title: 'Collect resources',
	},
	topicResources: {
		title: 'Collect resources',
		description: 'Select the resources you want to collect for this topic.',
		quick: {
			title: 'Curate resources',
			description: 'Quickly add the best matches for this topic.',
			submit: 'Curate selected',
		},
		expanded: {
			title: 'Gather more resources',
			description:
				'Choose sources and refine the search to discover better options.',
			submit: 'Gather selected',
		},
		searchQuery: {
			label: 'Search',
			placeholder: 'Type a search…',
			help: 'This search is used to find resources. If there are no results, try editing it.',
			hint: 'Adjust the text to broaden or narrow the results.',
			used: 'Search used: {{query}}',
		},
		resourceTypes: {
			label: 'Resource types',
			help: 'You can select more than one.',
			selectedCount_one: '{{count}} selected',
			selectedCount_other: '{{count}} selected',
			youtube: {
				title: 'Videos',
				description: 'Add videos related to this topic',
			},
			google_books: {
				title: 'Books',
				description: 'Add relevant books',
			},
			serper_article: {
				title: 'Web Articles',
				description: 'Add articles and blog posts',
			},
			serper_image: {
				title: 'Images',
				description: 'Add related images',
			},
			file_upload: {
				title: 'Files',
				description: 'Upload a PDF, image, or document',
			},
		},
		submit: 'Collect selected',
		loading: 'Loading configuration...',
		failures: {
			youtube: 'YouTube search failed. Please try again later.',
			googleBooks: 'Book search failed. Please try again later.',
			webSearch: 'Some web searches failed. Please try again later.',
			imageSearch: 'Some image searches failed. Please try again later.',
			generic: 'Some searches failed. Please try again later.',
		},
		status: {
			collectingTitle: 'Collecting resources…',
			collectingDescription: 'This may take a few seconds.',
			failedTitle: 'Failed to collect resources',
			failedDescription: 'Please try again later.',
			successTitle: 'Resources collected',
			successDescription: 'Collected {{count}} resources.',
			partialTitle: 'Resources collected (with warnings)',
			partialWarning:
				'Some sources failed. You can retry or adjust your selection.',
			typeStatus: {
				ok: 'OK',
				failed: 'Failed',
			},
			noResultsTitle: 'No resources found',
			noResultsDescription: 'Try adjusting your selection or search terms.',
		},
	},
	createArtifacts: {
		title: 'Create content',
		descriptionNamed: 'Create content for {{entityType}} "{{entityName}}".',
		multiSelectHint: 'Tip: you can select multiple facets before creating.',
	},
	unsplashImagePicker: {
		title: 'Select {{mainEntityLabelLower}} cover image',
		description:
			'Search and select an image from Unsplash to use as your {{mainEntityLabelLower}} cover.',
		searchLabel: 'Search images',
		selectedImage: 'Selected image',
		selectedAlt: 'Selected image',
		remove: 'Remove cover',
		replace: 'Replace cover',
		save: 'Save cover',
	},
	searchPublicCourses: {
		title: 'Search {{mainEntityLabelPluralLower}} & topics',
		description:
			'Find your {{mainEntityLabelPluralLower}}, topics, and discover published {{mainEntityLabelPluralLower}}',
		placeholder: 'Search {{mainEntityLabelPluralLower}}, topics...',
		searching: 'Searching...',
		emptyState: 'Start typing to search',
		noResults: 'No results found for "{{query}}"',
		tabs: {
			yourContent: 'Your content',
			brandContent: '{{brandName}} {{mainEntityLabelPluralLower}}',
		},
		actions: {
			enroll: 'Enroll',
			enrolling: 'Enrolling...',
		},
	},
	createModule: {
		title: 'Create new module',
		description: 'Complete the following fields to create a new module.',
		titlePlaceholder: 'Module name',
		descriptionPlaceholder: 'Module description (optional)',
	},
	createTopic: {
		title: 'Create new topic',
		description: 'Complete the following fields to create a new topic.',
		titlePlaceholder: 'Topic name',
		descriptionPlaceholder: 'Topic description (optional)',
		isOptional: 'Mark as optional',
	},
	searchEntity: {
		title: 'Search existing entity',
		description:
			'Search and add existing content to your {{mainEntityLabelLower}}.',
		searchLabel: 'Search',
		searchPlaceholder: 'Enter search terms',
		searching: 'Searching...',
		search: 'Search',
		resultsLabel: 'Results',
		fromCourse: 'From: {{courseName}}',
		queryRequired: 'Enter a search term',
		selectRequired: 'Select an item',
		noResults: 'No results found for "{{query}}"',
		adding: 'Adding...',
		add: 'Add selected',
	},
	confirmDelete: {
		title: 'Confirm deletion',
		description:
			'Are you sure you want to delete this {{entityType}}? This action cannot be undone.',
		descriptionNamed:
			'Are you sure you want to delete the {{entityType}} "{{entityName}}"? This action cannot be undone.',
	},
	deleteEntity: {
		title: 'Delete entity (placeholder)',
		description: 'This is a placeholder for the delete entity dialog.',
		placeholder: 'Functionality to delete an entity will be implemented here.',
	},
	uploadFile: {
		title: 'Upload file (placeholder)',
		description: 'This is a placeholder for the upload file dialog.',
		placeholder: 'Functionality to upload a file will be implemented here.',
	},
	userCourseWizard: {
		title: 'Create {{mainEntityLabelLower}}',
		description: 'Configure the details for your new {{mainEntityLabelLower}}',
		titleLabel: 'What do you want to learn?',
		titlePlaceholder:
			'e.g., Advanced react patterns, machine learning basics...',
		proNotice:
			'Personal {{mainEntityLabelLower}} creation uses AI preparation and is available for Pro subscribers.',
		context: {
			label: 'What context should shape this {{mainEntityLabelLower}}?',
			placeholder:
				'Your goal, constraints, preferred examples, project, deadline, or what you already know.',
			help: 'A few concrete details help create a better {{mainEntityLabelLower}} map than a title alone.',
		},
		languageLabel: 'Language',
		selectLanguage: 'Select language',
		modeLabel: 'Choose your creation mode',
		level: {
			label: 'Current level',
			beginner: 'Beginner',
			intermediate: 'Intermediate',
			advanced: 'Advanced',
		},
		depth: {
			label: '{{mainEntityLabel}} depth',
			value: '{{count}} topics',
			help: 'Start smaller if you want a practical first version; increase depth for a broader {{mainEntityLabelLower}} map.',
		},
		blueprints: {
			note: 'Each topic will receive topic-specific facet blueprints for optional on-demand work.',
		},
		courseTypeKey: {
			label: 'Course type',
			select: 'Select course type',
			blank: 'Blank',
			brand_default: 'Brand default',
			architect_profile: 'Architect profile',
			case_study: 'Case study',
			concept_deep_dive: 'Concept deep dive',
			tool_tutorial: 'Tool tutorial',
			professional_guide: 'Professional guide',
			help: 'Blank disables brand and taxonomy editorial bias during AI generation.',
		},
		steps: {
			details: 'Details',
			preferences: 'Preferences',
			review: 'Review',
		},
		diagram: {
			label: 'Create {{mainEntityLabel}} map diagram',
			help: 'Generate a visual entry surface during Phase 1.',
		},
		modes: {
			empty: {
				label: 'Empty {{mainEntityLabelLower}}',
				description: 'Start from scratch',
				detail: 'Create modules and topics manually at your own pace',
			},
			studyMap: {
				label: 'Study map',
				description: 'AI-generated structure',
				detail: 'AI creates modules and topics based on your title',
			},
			full: {
				label: 'Full {{mainEntityLabelLower}}',
				description: 'Complete learning path',
				detail: 'Structure + curated resources + learning materials',
			},
		},
		actions: {
			cancel: 'Cancel',
			create: 'Create {{mainEntityLabelLower}}',
			creating: 'Creating...',
		},
		validation: {
			titleRequired: 'Please enter a {{mainEntityLabelLower}} title',
			titleMinLength: 'Title must be at least 3 characters',
		},
		success: {
			empty: '{{mainEntityLabel}} created! Start adding modules and topics.',
			studyMap:
				'Study map created! Your {{mainEntityLabelLower}} structure is ready.',
			full: '{{mainEntityLabel}} created! Resources are being added in the background.',
		},
		errors: {
			generic: 'Failed to create {{mainEntityLabelLower}}. Please try again.',
		},
		review: {
			courseTitle: '{{mainEntityLabel}} title',
			creationMode: 'Creation mode',
			courseTypeKey: 'Course type',
			level: 'Level',
			depth: 'Depth',
			diagram: 'Diagram',
		},
	},
	createStudyPlan: {
		title: 'Create study plan',
		description: 'Configure the details for your new AI-generated study plan.',
		fields: {
			name: {
				label: '{{mainEntityLabel}} name',
				placeholder: 'e.g., Introduction to Quantum Computing',
			},
			practical: {
				label: '{{mainEntityLabel}} type',
				options: {
					practical: 'Practical',
					foundational: 'Foundational',
				},
				help: 'Practical focuses on hands-on projects. Foundational builds theoretical understanding.',
			},
			level: {
				label: 'Expertise level',
				options: {
					beginner: 'Beginner',
					intermediate: 'Intermediate',
					advanced: 'Advanced',
				},
			},
			language: {
				label: 'Language',
				options: {
					english: 'English',
					spanish: 'Spanish',
					french: 'French',
					german: 'German',
					portuguese: 'Portuguese',
					italian: 'Italian',
				},
			},
			topicsCount: {
				label: 'Total topics',
				placeholder: '12',
				help: 'Recommended: 8-24 topics',
			},
		},
		actions: {
			primary: 'Generate plan',
			secondary: 'Cancel',
		},
	},
}
